import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormLabel,
  IconButton,
  TextField,
  Modal,
} from "../../../components/ui";
import { Add, Delete, Edit, Pageview, Search } from "../../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { path } from "../../../navigation/path";
import { bgColor, modalStyle } from "../../../style/common";
import CompanyForm from "./CompanyForm";

const CompanyList = () => {
  const role: any = localStorage.getItem("role");
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [id, setId] = useState<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  const [companies, setCompanies] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filteredCompanies, setFilteredCompanies] = useState([]);

  console.log("ENV", process.env.BACKEND_URL);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setId(null);
    handleGetCompany();
  };

  const handleClear = () => {
    setData({ name: "", floor: "" });
  };

  const handleChage = (key: any, value: any) => {
    setData({ ...data, [key]: value });
  };

  const handleSubmit = () => {
    if (!data?.name) {
      toast.error("Name is required");
      return;
    } else if (!data?.floor) {
      toast.error("Floor is required");
      return;
    }
    if (data?.id) {
      handleUpdateCompany();
    } else {
      handleAddCompany();
    }
  };
  const handleAddCompany = async () => {
    try {
      const resp = await axiosInstance.post(
        `/api/company?invocation=${role}`,
        data
      );
      if (resp.status === 200) {
        setData({ name: "", floor: "" });
        handleGetCompany();
        if (role == 0) {
          toast.success("Company created successfully");
        } else if (role == 1) {
          toast.success("Your request has been sent to create a company");
        }
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleUpdateCompany = async () => {
    try {
      const resp = await axiosInstance.put(
        `/api/company/${data?.id}?invocation=${role}`,
        data
      );
      if (resp.status === 200) {
        setData({ name: "", floor: "" });
        handleGetCompany();
        toast.success("Company Updated successfully");
      }
    } catch (error: any) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleGetCompany = async () => {
    setLoading(true);
    try {
      const resp: any = await axiosInstance.get(
        `/api/company?searchQuery=${searchQuery}`
      );
      if (resp.status === 200) {
        setCompanies(resp.data?.data);
        setLoading(false);
      }
    } catch (error: any) {
      console.log(error?.response?.data?.message);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      const resp: any = await axiosInstance.delete(`/api/company/${id}`);
      if (resp.status === 200) {
        handleGetCompany();
        toast.success("Company deleted successfully");
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetCompany();
  }, [searchQuery]);

  useEffect(() => {
    setFilteredCompanies(
      companies.filter(
        (company: any) =>
          company.name.toLowerCase().includes(searchText.toLowerCase()) ||
          company.floor.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [searchText, companies]); // Re-filter when searchText or companies change

  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }} spacing={1}>
        <Grid size={12} display={"flex"} justifyContent={"space-between"}>
          <Typography fontSize={20} fontWeight={500} color="#111827">
            {" "}
            Company{" "}
            <IconButton onClick={handleOpen}>
              <Add sx={{ color: "#111827" }} />
            </IconButton>
          </Typography>
        </Grid>
        <Grid size={12}>
          <TextField
            size="small"
            id="outlined-basic"
            placeholder="Search company..."
            slotProps={{
              input: {
                endAdornment: <Search sx={{ color: "#111827" }} />,
              },
            }}
            variant="outlined"
            fullWidth
            onChange={(e: any) => setSearchText(e?.target?.value)}
          />
        </Grid>

        {!loading ? (
          <Grid size={12} container>
            {filteredCompanies?.map((item: any, index: any) => (
              <Grid size={3} key={index}>
                <Card
                  sx={{
                    borderRadius: 2,
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #E5E7EB",
                  }}
                >
                  <CardContent>
                    <Typography fontSize={18} fontWeight={500} color="#1F2937">
                      {item?.name}
                    </Typography>
                    <Typography fontSize={16} fontWeight={500} color="#1F2937">
                      Floor: {item?.floor}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 1,
                      }}
                    >
                      <IconButton
                        sx={{ color: "#1F2937" }}
                        onClick={() => {
                          setId(item?.id);
                          handleOpen();
                          // handleGet(item?.id);
                        }}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        sx={{ color: "#1F2937" }}
                        onClick={() => handleDelete(item?.id)}
                      >
                        <Delete />
                      </IconButton>
                      <IconButton
                        sx={{ color: "#1F2937" }}
                        onClick={() => navigate(`/company/${item?.id}`)}
                      >
                        <Pageview />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <>
            {" "}
            <Box
              height={"80vh"}
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <CircularProgress color="secondary" />
            </Box>
          </>
        )}
      </Grid>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <CompanyForm onClose={handleClose} id={id} />
        </Box>
      </Modal>
    </div>
  );
};

export default CompanyList;
